module.exports = __webpack_public_path__ + "static/media/flavor-hover.0c2d57ab.png";